<script setup lang="tsx">
import { useI18n } from 'vue-i18n'
import {
	Implemented,
	NotImplemented,
	NeedsAttention,
	WillNotApply,
	WillNotImplement,
	PartiallyImplemented,
	ConditionallyImplemented,
} from '@/models/enums-generated'

const props = defineProps({
	id: String,
})
const model = defineModel({ default: NotImplemented })

const { t } = useI18n()

const statuses = [
	{
		value: NotImplemented,
		text: t('status.notImplemented'),
		disabled: false,
	},
	{
		value: Implemented,
		text: t('status.implemented'),
		disabled: false,
	},
	{
		value: WillNotImplement,
		text: t('status.willNotImplement'),
		disabled: false,
	},
	{
		value: NeedsAttention,
		text: t('status.needsAttention'),
		disabled: false,
	},
	{
		value: WillNotApply,
		text: t('status.willNotApply'),
		disabled: false,
	},
	{
		value: ConditionallyImplemented,
		text: t('status.conditionallyImplemented'),
		disabled: true,
	},
	{
		value: PartiallyImplemented,
		text: t('status.partiallyImplemented'),
		disabled: true,
	},
]
</script>

<template>
	<select :id="props.id" class="form-select" v-model="model">
		<option v-for="status in statuses" :key="status.value" :value="status.value" :disabled="status.disabled">
			{{ status.text }}
		</option>
	</select>
</template>
